module.exports = __webpack_public_path__ + "img/p.8dbbc37a.jpg";